<template>
  <app-lazy
    v-for="(group, i) in groupedAndSortedCourses"
    :key="`featured-${i}`"
    :style="getSliderStyle(group)"
  >
    <component
      :is="
        group.themeSize === 'full' && !isDesktopScreen
          ? FeaturedFullSlider
          : FeaturedSlider
      "
      :featured-slider-data="group.courses"
      :theme-name="group.themeName"
      :theme-size="group.themeSize"
      class="mb-6"
    />
  </app-lazy>
</template>

<script setup>
import FeaturedSlider from '@/components/featured/FeaturedSlider.vue';
import FeaturedFullSlider from '@/components/featured/FeaturedFullSlider.vue';
import { computed } from 'vue';
import AppLazy from '@/components/common/AppLazy';
import useDeviceScreen from '@/composables/useDeviceScreen';

defineOptions({
  name: 'FeaturedSlidersContainer',
});

const props = defineProps({
  featuredSlidersData: {
    type: Array,
    required: true,
  },
});

const groupedAndSortedCourses = computed(() => {
  const map = new Map();

  props.featuredSlidersData.forEach((course) => {
    course.themes.forEach((theme) => {
      const themeName = theme.name;
      const themeSize = theme.size;

      if (!map.has(themeName)) {
        map.set(themeName, {
          themeName,
          themeSize,
          position: theme.position,
          courses: [],
        });
      }
      map.get(themeName).courses.push(course);
    });
  });

  return [...map.values()].sort((a, b) => a.position - b.position);
});

const getSliderStyle = (group) => {
  return { order: group.position ?? 0 };
};

const { isDesktopScreen } = useDeviceScreen();
</script>
